import React from "react";
import {
  AdjustCartItemVariantSubscriptionInput,
  CartFragment,
  V3ValidationErrorFragment,
} from "services/graphql/generated";

export interface CartContextInterface {
  cart: CartFragment | null;
  loading: boolean;
  validationErrors: V3ValidationErrorFragment[];
  refreshCart(): void;
  addCartItem(_dto: AdjustCartItemVariantSubscriptionInput): Promise<void>;
  updateCartItem(_dto: AdjustCartItemVariantSubscriptionInput): Promise<void>;
  getSize(): number | undefined;
  getCartId(): string | null;
}

export const CartContext = React.createContext<CartContextInterface>({
  cart: null,
  loading: true,
  validationErrors: [],
  refreshCart: () => {},
  addCartItem: async (_dto: AdjustCartItemVariantSubscriptionInput) => {},
  updateCartItem: async (_dto: AdjustCartItemVariantSubscriptionInput) => {},
  getSize: () => {
    return 0;
  },
  getCartId: () => null,
});
